import { inject, Provider } from '@angular/core';

import { Cb2PreviewStateService } from '@core/services/cb2-preview/cb2-preview-state.service';

import {
  CART_VOUCHER_BLOCK_DATA_SOURCE,
  CartVoucherBlockDataSource,
} from './cart-voucher-block-view-model';
import { CartVoucherBlockPreviewDataSource } from './cart-voucher-block-preview-data-source';
import { CartVoucherBlockStoreDataSource } from './cart-voucher-block-store-data-source';

export function provideCartVoucherBlockDataSource(): Provider[] {
  return [
    CartVoucherBlockStoreDataSource,
    CartVoucherBlockPreviewDataSource,
    {
      provide: CART_VOUCHER_BLOCK_DATA_SOURCE,
      useFactory: (): CartVoucherBlockDataSource => {
        const previewState = inject(Cb2PreviewStateService);
        return previewState.isActive()
          ? inject(CartVoucherBlockPreviewDataSource)
          : inject(CartVoucherBlockStoreDataSource);
      },
    },
  ];
}
